var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { forwardRef } from "react";
import { useId } from "./util/useId";
const SvgWrenchFill = forwardRef((_a, ref) => {
    var { title, titleId: _titleId } = _a, props = __rest(_a, ["title", "titleId"]);
    let titleId = useId();
    titleId = title ? (_titleId ? _titleId : "title-" + titleId) : undefined;
    return (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", focusable: false, role: "img", ref: ref, "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.823 4.399C10.47 3.045 8.46 2.789 6.72 3.463a.75.75 0 0 0-.26 1.23l1.76 1.76c.083.082.092.2.038.284-.173.274-.424.642-.652.87-.227.227-.595.478-.869.651a.229.229 0 0 1-.284-.037l-1.76-1.76a.75.75 0 0 0-1.23.259c-.674 1.74-.419 3.75.936 5.103C5.624 13.05 7.387 13.375 9 12.925l6.021 6.595c.814.891 2.2 1.21 3.298.468.316-.213.656-.468.928-.74.272-.272.527-.612.74-.928.74-1.098.423-2.484-.468-3.298l-6.595-6.021c.45-1.614.124-3.376-1.102-4.602Zm5.088 11.84a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 0-1.5h-.01Z", fill: "currentColor" })));
});
export default SvgWrenchFill;
